module.exports = __webpack_public_path__ + "static/img/FLK_store.bd6ec35d.png";